module.exports = __webpack_public_path__ + "static/media/display-toggle.3cd6d03d.svg";